import { render, staticRenderFns } from "./IncomingInvoiceContent2.vue?vue&type=template&id=3195c51d&"
import script from "./IncomingInvoiceContent2.vue?vue&type=script&lang=js&"
export * from "./IncomingInvoiceContent2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports